/* @ngInject */
export function animateProviderConfig ($animateProvider) {
	$animateProvider.classNameFilter(/^(?!.*ng-animate-disabled).*$/);
}
